define('CustomStockBehavior', [
  'underscore'
], function KodellaCustomStockBehavior(
  _
) {
  'use strict';

  var ALLOW_BACKORDER = 'Allow Backorder';
  var DISALLOW_BACKORDER_W_DEFAULT_MESSAGE = 'Disallow Backorder w/ Default Message';
  var ALLOW_BACKORDER_W_DEFAULT_MESSAGE = 'Allow Backorder w/ Default Message';
  var customOutOfStockConfig;
  var ItemKeyMapping;
  var QuickAddItemsSearcherPlugins;
  var ProductModel;
  var ItemModel;
  var ProductCollection;
  var QuickAddItemView;
  var CartLinesView;
  var jQuery;

  try {
    ItemKeyMapping = require('Item.KeyMapping');
    ItemKeyMapping.getKeyMapping = _.wrap(ItemKeyMapping.getKeyMapping, function wrap(fn) {
      var results = fn.apply(this, Array.prototype.slice.call(arguments, 1));
      var customBehavior = customOutOfStockConfig && customOutOfStockConfig.outOfStockBehavior;
      var isLoggedIn = customOutOfStockConfig.isLoggedIn;
      var isPurchasableDefaultValue = results._isPurchasable;

      if (_.isFunction(results._isPurchasable)) {
        results._isPurchasable = _.wrap(results._isPurchasable, function wrap2(isPurchasableFn, item) {
          var isPurchasableResults = isPurchasableFn.apply(this, Array.prototype.slice.call(arguments, 1));
          var isInstock = item.get('isinstock');
          if (customBehavior && !isInstock) {
            return customBehavior !== DISALLOW_BACKORDER_W_DEFAULT_MESSAGE;
          }
          return isPurchasableResults;
        });
      } else {
        results._isPurchasable = function _isPurchasable(item) {
          if (customBehavior) {
            var itemValue = item.get(isPurchasableDefaultValue);
            var isInstock = item.get('isinstock');
            if (itemValue !== false && !isInstock) {
              return customBehavior !== DISALLOW_BACKORDER_W_DEFAULT_MESSAGE;
            }
          }
          return isPurchasableDefaultValue;
        };
      }

      results._isBackorderable = function _isBackorderable(item) {
        if (customBehavior) {
          return customBehavior !== DISALLOW_BACKORDER_W_DEFAULT_MESSAGE;
        }
        return item.get('isbackorderable');
      };

      results._showOutOfStockMessage = function _showOutOfStockMessage(item) {

        if (customBehavior) {
          return customBehavior !== ALLOW_BACKORDER && isLoggedIn;
        }
        return item.get('showoutofstockmessage');
      };

      results._outOfStockMessage = function _outOfStockMessage(item) {
        var outOfStockDefaultMessage = customOutOfStockConfig && customOutOfStockConfig.outOfStockDefaultMessage;
        return outOfStockDefaultMessage || item.get('outofstockmessage2') || item.get('outofstockmessage');
      };

      return results;
    });
  } catch (e) {
    console.warn('Error' + e);
  }

  try {
    QuickAddItemsSearcherPlugins = require('QuickAdd.ItemsSearcher.Plugins');
    ProductModel = require('Product.Model');
    ItemModel = require('Item.Model');
    ProductCollection = require('Product.Collection');
    if (QuickAddItemsSearcherPlugins && QuickAddItemsSearcherPlugins.flatItemsMatrixResult) {
      _.extend(QuickAddItemsSearcherPlugins.flatItemsMatrixResult, {
        execute: function (collection, configuration) {
          var products = [];
          var newProduct;
          var itemOptions;
          var internalidCounter = 1;
          collection.each(function (item) {
            if (item.get('_matrixChilds') && item.get('_matrixChilds').length) {
              itemOptions = item.get('options').where({ isMatrixDimension: true });

              item.get('_matrixChilds').each(function (childItem) {
                newProduct = new ProductModel({
                  item: new ItemModel(_.extend({}, item.attributes))
                });

                _.each(itemOptions, function (option) {
                  var selectedChildItemOptionLabel = childItem.get(
                    option.get('itemOptionId')
                  );
                  var selectedOptionValueObject = _.findWhere(
                    option.get('values'),
                    { label: selectedChildItemOptionLabel }
                  );

                  newProduct.setOption(
                    option.get('cartOptionId'),
                    selectedOptionValueObject.internalid
                  );
                });

                newProduct
                  .getItem()
                  .set('itemimages_detail', item.get('itemimages_detail'));

                newProduct.set('isfulfillable', item.get('isfulfillable'));
                newProduct.set('internalid', internalidCounter++);

                products.push(newProduct);
              });
            } else {
              products.push(
                new ProductModel({
                  item: item,
                  internalid: internalidCounter++
                })
              );
            }
          });

          products = _.filter(products, function (product) {
            var queryOnSku =
                            (product.getSku() ? product.getSku().toUpperCase() : '').indexOf(
                              configuration.query.toUpperCase()
                            ) >= 0;
            var queryOnName =
                            (product.get('item').get('_name')
                              ? product
                                .get('item')
                                .get('_name')
                                .toUpperCase()
                              : ''
                            ).indexOf(configuration.query.toUpperCase()) >= 0;
            var itemNotGiftCertificate =
                            product.get('item').get('itemtype') !== 'GiftCert';

            return itemNotGiftCertificate && (queryOnName || queryOnSku);
          });

          return new ProductCollection(_.first(products, configuration.limit));
        }
      });
    }
  } catch (e) {
    console.warn('Error' + e);
  }

  try {
    QuickAddItemView = require('QuickAdd.Item.View');
    jQuery = require('jQuery');

    if (QuickAddItemView) {
      _.extend(QuickAddItemView.prototype, {
        getContext: _.wrap(QuickAddItemView.prototype.getContext, function (fn) {
          var ret = fn.apply(this, Array.prototype.slice.call(arguments, 1));
          var stockBehaviour = customOutOfStockConfig.outOfStockBehavior;
          ret.isOutOfStock = ret && ret.model && ret.model.get('item') && !ret.model.get('item').get('isinstock');
          ret.outOfStockMessage = customOutOfStockConfig.outOfStockDefaultMessage;
          if (stockBehaviour === DISALLOW_BACKORDER_W_DEFAULT_MESSAGE) {
            jQuery('document').ready(function () {
              jQuery('.custom-container').parent().removeClass('tt-selectable');
            });
          }
          return ret;
        }),

        events: {
          'click [data-type="quick-add-reset"]': 'resetHandle',
          'submit form': 'saveForm',
          'click [data-action="plus"]': 'addQuantity',
          'click [data-action="minus"]': 'subQuantity',
          'change [data-type="quantity-input"]': 'setQuantity',
          'click [data-type="quantity-input"]': 'selectAll',
          'keypress [name="quantity"]': 'submitOnEnter',
          'keydown [name="quantity"]': 'onKeyDown',
          'click [data-action="redirect-pdp"]': 'redirectPDP'
        },

        redirectPDP: function () {
          var stockBehaviour = customOutOfStockConfig.outOfStockBehavior;
          if (stockBehaviour === DISALLOW_BACKORDER_W_DEFAULT_MESSAGE) {
            if(this.model && this.model.get('item') && this.model.get('item').get('urlcomponent')) {
              window.location.href = this.model.get('item').get('urlcomponent');
            }
          }
        }
      });
    }
  } catch (e) {
    console.warn('Error' + e);
  }

  try {
    CartLinesView = require('Cart.Lines.View');
    if (CartLinesView) {
      _.extend(CartLinesView.prototype, {
        getContext: _.wrap(CartLinesView.prototype.getContext, function (fn) {
          var ret = fn.apply(this, Array.prototype.slice.call(arguments, 1));
          var stockBehaviour = customOutOfStockConfig.outOfStockBehavior;
          if (stockBehaviour === ALLOW_BACKORDER_W_DEFAULT_MESSAGE) {
            if (ret.item && !ret.item.get('isinstock')) {
              ret.showOutOfStockMessage = true;
              ret.outOfStockMessage = customOutOfStockConfig.outOfStockDefaultMessage;
            }
          }
          return ret;
        })
      });
    }
  } catch (e) {
    console.warn('Error' + e);
  }

  return {
    mountToApp: function mountToApp(container) {
      var env = container.getComponent('Environment');
      var userProfileComponent = container.getComponent('UserProfile');
      var layout = container.getComponent('Layout');
      customOutOfStockConfig = env && env.getConfig('CustomStockBehavior') || {};

      userProfileComponent.getUserProfile().then(function (profile) {
        customOutOfStockConfig.isLoggedIn = profile.isloggedin;
      });

      layout.on('beforeShowContent', function () {
        return userProfileComponent.getUserProfile().then(function (profile) {
          customOutOfStockConfig.isLoggedIn = profile.isloggedin;
        });
      });
    }
  };
});
